import { observer } from 'mobx-react';
import React, { Suspense } from 'react';
import querystring from 'querystring';


const LoadingComponent = observer(function LoadingComponent() {
  return <div className="lazy-loading-suspense">{/* content here just creates a noise, no need */}</div>;
})

export function renderComponent(Component, match, props) {
  const parsed = querystring.parse(root.location.search.substring(1));
  Object.keys(parsed).forEach(k => {
    if (parsed[k] === '') parsed[k] = true;
  });
  const path = root.location.pathname;
  const url = root.location.pathname + root.location.search;

  const componentProps = {
    routePath: path,
    routeUrl: url,
    routeQuery: { ...parsed, ...match },
    ...props,
  };
  if (Component) {
    if (Component.type && Component.props) {
      return Component;
    }
    return (
      <Suspense fallback={<LoadingComponent />}>
        <Component key={props.key} {...componentProps} />
      </Suspense>
    );
  }
  return null;
}

export function renderOneComponent(routes) {
  const activeRoute = routes.find(d => d.to === root.location.pathname);
  if (activeRoute) { return renderComponent(activeRoute.component, true, { key: root.location.pathname }); }
  return '';
}

export function getUrl(to, query) {
  const [pathname, search] = (to || '').split('?');
  let q = {};
  // get query from string
  if ((search + '').trim()) q = querystring.parse(search);

  // extend with query in props
  Object.assign(q, query || {});

  let url = pathname;
  const queryStr = querystring.stringify(q);
  if (queryStr) url += '?' + queryStr;

  return url;
}

export function replaceQuery(query, keepOnPage = true, skipCheckEdits = false) {
  const queryUrl = querystring.parse(root.location.search.slice(1));

  const queryNotNull = {};
  Object.keys(query).forEach(d => { if (query[d] !== null) queryNotNull[d] = query[d]; });

  const queryUrlNew = {};
  Object.keys(queryUrl).forEach(d => { if (query[d] !== null) queryUrlNew[d] = queryUrl[d]; });

  const to = root?.location?.pathname?.substr?.(1);
  Object.assign(queryUrlNew, queryNotNull);
  const url = getUrl(to, queryUrlNew);

  const cancel = (!skipCheckEdits && root.app?.onUrlChange) ? root.app.onUrlChange(null, queryUrlNew) : false;
  if (cancel) return;

  if (keepOnPage) root.location.replace(url);
  else root.location.push('?' + querystring.stringify(queryUrlNew));
}

export function getRouteQuery() {
  try {
    const search = window?.location?.href?.split?.('?');
    if (search?.length > 0) return querystring.parse(search[1]);
    return {};
  } catch (e) {
    console.log('getRouteQuery e', e);
    return {};
  }
}
